import { Injectable } from '@angular/core';
import {of} from 'rxjs';
import {Observable} from 'rxjs';
import {delay} from 'rxjs/operators';
import {IBullhornFields, ICustomPairings, IEntityWeights} from '../../datatools-settings/weight-table/weights-interfaces';

@Injectable({
  providedIn: 'root'
})
export class DummyDataService {
  minSeconds = 2;
  maxSeconds = 8;

  constructor() {
  }

  getAllDuplikitWeights(): Observable<IEntityWeights> {
    return of(
      {
        candidate: {
          ssn: 5,
          AnyEmail: 3,
          AnyPhone: 3,
          first_name: 1,
          last_name: 1,
          date_of_birth: 0.5,
          address1: 0.2,
          address2: 1,
          city: 0.3,
          state: 1,
          countryID: 1,
          zip: 1,
          custom1: 0,
          custom2: 0
        },
        contact: {
          AnyEmail: 3,
          AnyPhone: 3,
          first_name: 5,
          last_name: 1,
          address1: 0.2,
          address2: 1,
          city: 1,
          state: 1,
          zip: 1,
          countryID: 1,
          custom1: 0,
          custom2: 0
        },
        company: {
          name: 5,
          sanitised_name: 4.9,
          phone: 1,
          fax: 1,
          companyurl: 1,
          address1: 0.2,
          address2: 0.2,
          city: 1,
          state: 1,
          zip: 1,
          countryID: 1,
          custom1: 0,
          custom2: 0
        }
      }
    ).pipe(
      delay(
        (Math.random() * (this.maxSeconds - this.minSeconds) * 1000)
      )
    );
  }

  getBullhornFieldOptions(): Observable<IBullhornFields> {
    return of({
      candidate: [
        {fieldName: 'customText1', fieldLabel: 'Special Field', dataType: 'String', type: 'String'},
        {fieldName: 'customInt2', fieldLabel: 'My Identifier', dataType: 'Integer', type: 'Integer'}
      ],
      contact: [
        {fieldName: 'customText3', fieldLabel: 'Contact Number', dataType: 'String', type: 'String'},
        {fieldName: 'customInt4', fieldLabel: 'Unique ID', dataType: 'Integer', type: 'Integer'}
      ],
      company: [
        {fieldName: 'customText5', fieldLabel: 'Favourite Food', dataType: 'String', type: 'String'},
        {fieldName: 'customInt6', fieldLabel: 'Awesomeness 1-5', dataType: 'Integer', type: 'Integer'}
      ],
    }).pipe(
      delay(
        (Math.random() * (this.maxSeconds - this.minSeconds) * 1000)
      )
    );
  }

  getAllCustomWeightSelections(): Observable<ICustomPairings> {
    return of(
      {
        candidate: [
          {fieldIdentifier: 'custom1', bullhornField: 'customText1'},
          {fieldIdentifier: 'custom2', bullhornField: 'customInt2'}
        ],
        contact: [
          {fieldIdentifier: '', bullhornField: ''}
        ],
        company: [
          {fieldIdentifier: 'custom1', bullhornField: 'customDate3'},
        ]
      }
    ).pipe(
      delay(
        (Math.random() * (this.maxSeconds - this.minSeconds) * 1000)
      )
    );
  }

  saveAllWeights(): Observable<any> {
    return of(true).pipe(
      delay(
        (Math.random() * (this.maxSeconds - this.minSeconds) * 1000)
      )
    );
  }

  saveCustomWeightSelections(): Observable<any> {
    return of(true).pipe(
      delay(
        (Math.random() * (this.maxSeconds - this.minSeconds) * 1000)
      )
    );
  }
}
